export default __webpack_public_path__ + "static/media/weblobster.c987ea6e.png";